var BufferFormatter = require('bufferformatter');
var ContextMenuView = require('contextmenuview');
var Formatter = require('formatter');
var twitch = require('../lib/twitch.es6');


var MemberContextMenuView = ContextMenuView.extend({
    el: '#memberContextMenu',
    initialize: function (options) {
        _.bindAll(this, 'focusMessage');
        
        ContextMenuView.prototype.initialize.call(this, options);
        
        this.title = this.$('h3.title');
        this.realname = this.$('.realname');
        this.status = this.$('.status');
        this.pronouns = this.$('.pronouns');
        this.bot = this.$('.bot');
        this.account = this.$('.account');
        this.away = this.$('.away');
        this.form = this.$('form.messageForm');
        this.message = this.$('input.message');
        this.hostmask = this.$('.hostmask');
        this.admin = this.$('.admin');
        this.twitchLink = this.$('.twitchLink');
        this.slackLink = this.$('.slackLink');
        this.server = this.$('.server');
        this.modActions = this.$('.modAction');
        this.whois = this.$('.whois');
        this.invite = this.$('.invite');
        this.relayBotEnable = this.$('.relayBotEnable');
        this.relayBotDisable = this.$('.relayBotDisable');
        this.opMember = this.$('.opMember');
        this.deopMember = this.$('.deopMember');
        this.voiceMember = this.$('.voiceMember');
        this.devoiceMember = this.$('.devoiceMember');
        this.kickMember = this.$('.kickMember');
        this.actions = this.$('.actions');
    },
    events: $.extend({}, ContextMenuView.prototype.events, {
        'submit form': 'submitForm',
        'click h3.title a': 'clickOpen',
        'click .memberContextMenu__titleLink': 'clickOpen',
        'buttonClick button.open': 'clickOpen',
        'buttonClick button.whois': 'clickWhois',
        'buttonClick button.invite': 'clickInvite',
        'buttonClick button.ignore': 'clickIgnore',
        'buttonClick button.relayBotEnable': 'clickRelayBotEnable',
        'buttonClick button.relayBotDisable': 'clickRelayBotDisable',
        'buttonClick button.kick': 'clickKick',
        'buttonClick button.op': 'clickOp',
        'buttonClick button.deop': 'clickDeop',
        'buttonClick button.voice': 'clickVoice',
        'buttonClick button.devoice': 'clickDevoice',
        'buttonClick button.ban': 'clickBan'
    }),
    clearContext: function () {
        this.formatter = null;
        this.user = null;
        this.resolved = null;
        this.member = null;
        this.message.val('');
        this.title.empty();
        this.realname.empty();
        this.status.empty();
        this.pronouns.empty();
        this.bot.empty();
        this.account.empty();
        this.account.removeClass('authed');
        this.$el.removeClass(
            'avatars-on avatars-image-on avatars-image-off avatars-noexternal avatars-external'
        );
        this.hostmask.empty();
        this.away.empty();
        this.admin.empty();
        this.twitchLink.empty();
        this.slackLink.empty();
        this.server.empty();
        this.actions.hide();
        this.modActions.hide();
        this.whois.hide();
        this.invite.hide();
        this.relayBotEnable.hide();
        this.relayBotDisable.hide();
        this.opMember.hide();
        this.deopMember.hide();
        this.voiceMember.hide();
        this.devoiceMember.hide();
        this.kickMember.hide();
    },
    getModeString: function () {
        var modeString = '';
        
        if (this.member) {
            var originalMode = this.user.getMode();
            var originalHost = this.user.getHostMask();
            var memberMode = this.member.getMode();
            var modeChange;
            if (this.user.message && (
                (!originalMode && memberMode)
             || (originalMode && !memberMode)
             || (originalMode != memberMode)
            )) {
                modeChange = true;
            }
            
            // Clicked user mode differs from member mode
            if (originalMode || modeChange) {
                modeString += this.user.getModeTitle();
            }
            if (modeChange) {
                // Clicked user mode differs from member mode
                modeString += ' → ';
            }
            
            // Resolved user mode
            if (modeChange || (memberMode && !originalHost && !originalMode)) {
                if (memberMode) {
                    modeString += this.member.getModeTitle();
                } else {
                    modeString += 'demoted';
                }
            }
        }
        return modeString;
    },
    resolveUser: function (user) {
        this.user = user;
        this.resolved = this.user;
        this.buffer = this.user.buffer || this.model.currentBuffer;
        if (this.buffer && this.buffer.isChannel()) {
            this.member = this.buffer.getMember(this.user.getName());
            var originalHostmask = this.user.getHostMask();
            if (this.member) {
                // Check member host
                if (this.buffer.connection.hasMeaningfulHostnames()) {
                    var memberHost = this.member.getHostMask();
                    if (originalHostmask && memberHost && memberHost != originalHostmask) {
                        // hosts don't match, this message is not from the matching nick member
                        this.member = null;
                    } else if (memberHost) {
                        this.resolved = this.member;
                    }
                } else if (this.member && !this.resolved.message) {
                    this.resolved = this.member;
                }
            }
            
            // If no member matches the same nick they might have left or changed nick
            if (!this.member && originalHostmask) {
                this.member = this.buffer.getMemberByUsermask(originalHostmask);
                if (this.member) {
                    // There's a member with this hostmask, they must have changed nick
                    this.resolved = this.member;
                }
            }
        }
    },
    show: function (user, x, y) {
        this.clearContext();
        
        this.message.val('');
        
        this.resolveUser(user);
        
        if (this.buffer) {
            this.formatter = new BufferFormatter(this.buffer);
        } else {
            this.formatter = new Formatter();
        }
        
        // Nickchange
        var nick = this.resolved.getName();
        var originalNick = this.user.getName();
        if (nick.toLowerCase() != originalNick.toLowerCase()) {
            this.title.text(originalNick + ' → ');
        }
        
        var titleLinkOpts = {className: 'memberContextMenu__titleLink', name: nick};
        var titleLink;
        var isRelayMsg = false;
        var relayMsgParts;
        var displayAuthor = this.resolved.getDisplayAuthor();
        if (displayAuthor) {
            titleLinkOpts.name = displayAuthor;
        }
        var isBot, isRelayBot, isRelayBotMatch;
        var userMessage = this.resolved.message || this.user.message;
        if (userMessage) {
            isBot = userMessage.isBot();
            isRelayBotMatch = userMessage.matchRelayBot();
            isRelayBot = userMessage.isRelayBot();
            displayAuthor = userMessage.getDisplayAuthor();
            if (displayAuthor) {
                relayMsgParts = userMessage.relayMsgParts(displayAuthor);
                displayAuthor = relayMsgParts.nick;
                var userDisplayName = userMessage.getUserDisplayName() ||
                    userMessage.getNick();
                var messageDisplayName = userMessage.getMessageDisplayName();
                if (messageDisplayName && messageDisplayName != userDisplayName) {
                    titleLinkOpts.suffix = ' (' + userDisplayName + ')';
                }
            } else {
                relayMsgParts = userMessage.relayMsgParts(
                    this.resolved.getDisplayAuthor() || nick
                );
                displayAuthor = relayMsgParts.nick;
            }
            if (relayMsgParts.relay) {
                isRelayMsg = true;
            }
            titleLinkOpts.name = relayMsgParts.nick;
            var twitchTags = userMessage.getTwitchTags();
            if (twitchTags) {
                titleLinkOpts.title = '';
                titleLinkOpts.prefix = this.formatter.renderTwitchBadges(userMessage);
            }
        }
        if (this.resolved.connection.isTwitch()) {
            this.twitchLink.html($('<a target="_blank">').attr('href', this.resolved.getTwitchUrl()).text('Twitch profile').prepend('<i class="fa fa-twitch">'));
        }

        var botUrl = this.resolved.get('bot_url');
        if (relayMsgParts && relayMsgParts.relay) {
            var botHtml = 'Relayed by:&nbsp;' + this.formatter.escapeText(relayMsgParts.relay);
            if (relayMsgParts && relayMsgParts.server) {
                botHtml += '<br>Relayed from:&nbsp;' + this.formatter.escapeText(relayMsgParts.server);
            }
            this.bot.html(botHtml);
        } else if (botUrl) {
            // Sanitise link
            var cleanLink = this.formatter.linker.makeLinkFromUrl(botUrl);
            if (!cleanLink) {
                cleanLink = this.formatter.escapeText(botUrl);
            }

            this.bot.html('Bot:&nbsp;' + cleanLink);
        } else if (isRelayBot) {
            this.bot.html('Relay Bot');
        } else if (isBot) {
            this.bot.html('Bot');
        }

        var slackBot = false;
        if (this.resolved.connection.isSlack()) {
            titleLinkOpts.title = '';
            if (botUrl || isBot) {
                slackBot = true;
            } else {
                this.slackLink.html($('<a target="_blank">').attr('href', this.resolved.getSlackUrl()).text('Slack profile').prepend('<i class="fa fa-slack">'));
            }
        }
        if (this.member) {
            // Include mode if it's a member
            titleLink = this.formatter.linkUserMode(this.member, titleLinkOpts);
        } else {
            titleLink = this.formatter.linkUser(this.resolved, titleLinkOpts);
        }
        this.title.append(titleLink);
        twitch.loadBadges(this.model, this.buffer.normalise(), this.title);
        
        // Mode
        var modeString = this.getModeString();
        if (modeString) {
            this.title.append(' (' + this.formatter.escapeText(modeString) + ')');
        }
        
        this.$el.addClass('avatars-on');
        if ((this.buffer || this.model).imageAvatarsEnabled()) {
            this.$el.addClass('avatars-image-on');
        } else {
            this.$el.addClass('avatars-image-off');
        }
        if ((this.buffer || this.model).embedExternalAvatars()) {
            this.$el.addClass('avatars-external');
        } else {
            this.$el.addClass('avatars-noexternal');
        }
        this.title.prepend(this.avatar());

        if (this.resolved.connection.hasMeaningfulHostnames()) {
            if (
                this.buffer &&
                this.buffer.isChannel() &&
                this.buffer.userMember &&
                !isRelayMsg &&
                !this.member
            ) {
                // There's no member with this hostmask or nick, and we're still in it they must have parted the channel
                this.title.append(' → left');
            }
            this.whois.show();
            this.invite.show();
            var hostmask = this.resolved.getHostMask();
            if (hostmask) {
                this.hostmask.html(this.formatter.renderNoEmoji(hostmask));
            }
        }

        if (isRelayBot) {
            this.relayBotDisable.show();
        } else if (isRelayBotMatch) {
            this.relayBotEnable.show();
        }
        
        if (this.model.isAdmin()) {
            var uid = this.resolved.irccloudUid() || (this.member ? this.member.irccloudUid() : null);
            if (uid) {
                this.admin.html($('<a target="_blank">').attr('href', this.model.getOrigin() + '/$/user/' + encodeURIComponent(uid)).text('User: ' + uid));
            }
        }
        
        var away = this.resolved.getAway();
        if (away) {
            var awayMsg = '<small>Away';
            if (away !== true && away.toLowerCase() != 'away') {
                awayMsg += ': ' + this.formatter.renderLinkify(away);
            }
            awayMsg += '</small>';
            this.away.html(awayMsg);
        }
        
        var realname = this.resolved.getRealname();
        if (realname) {
            this.realname.html(this.formatter.renderLinkify(realname));
        }

        var pronouns = this.resolved.getPronouns();
        if (pronouns) {
            this.pronouns.html('Pronouns: ' + this.formatter.renderLinkify(pronouns));
        }

        var status = this.resolved.getStatusText();
        if (status) {
            this.status.html('Status: ' + this.formatter.renderLinkify(status));
        }

        var account = this.resolved.get('account');
        if (!slackBot && account && account != '*') {
            this.account.addClass('authed');
            this.account.html('Logged in as: <b>' + this.formatter.renderLinkify(account) + '</b>');
        }
        
        var server = this.resolved.get('ircserver');
        if (server) {
            this.server.text('(' + server + ')');
        }
        
        if (this.buffer && this.buffer.isChannel()) {
            // Mod actions
            if (this.buffer.userMember) {
                if (this.member && this.buffer.userMember.canOp()) {
                    if (this.member.canOp()) {
                        this.deopMember.show();
                    } else {
                        this.opMember.show();
                    }
                }
                if (this.buffer.userMember.isMod()) {
                    this.modActions.show();
                    // Kick
                    if (this.member) {
                        this.kickMember.show();
                        if (this.member.isVoiced()) {
                            this.devoiceMember.show();
                        } else {
                            this.voiceMember.show();
                        }
                    }
                }
            }
        }
        
        this.actions.show();
        
        ContextMenuView.prototype.show.call(this, x + 1, y - 5);
    },
    avatar: function () {
        var img = $();
        if ((this.buffer || this.model).avatarsEnabled()) {
            var nick = this.resolved.getName();
            var avatar;
            if ((this.buffer || this.model).imageAvatarsEnabled()) {
                avatar = this.resolved.getAvatar();
                // TODO overlay message avatar on user avatar
                if (!avatar && this.resolved.message) {
                    var messageAvatar = this.resolved.message.getAvatar();
                    if (messageAvatar) {
                        avatar = messageAvatar;
                    }
                }
            }
            var external = false;
            if (avatar) {
                external = avatar.external;
                img = img.add(this.formatter.imageAvatar(avatar.src, this.resolved.isSelf(), {
                    size: 512,
                    no2x: true,
                    external: external
                }));
            } else if (this.resolved.connection.isTwitch()) {
                avatar = true;
                var idx = this.formatter.getNickColorIndex(nick, {
                    length: twitch.numDefaultAvatars()
                });
                var twitchAvatar = $(this.formatter.imageAvatar(twitch.defaultAvatar({idx: idx}), this.resolved.isSelf(), {
                    size: 300,
                    external: true
                }));
                img = img.add(twitchAvatar);
                twitch.channelsToInfo(
                    this.model, [nick]
                ).then(_.bind(function (channelInfo) {
                    if (channelInfo && channelInfo[nick]) {
                        var logoSrc = channelInfo[nick].logo.replace('300x300.', '{size}x{size}.');
                        var newTwitchAvatar = $(this.formatter.imageAvatar(logoSrc, this.resolved.isSelf(), {
                            size: 300,
                            external: true
                        }));
                        twitchAvatar.replaceWith(newTwitchAvatar);
                    }
                }, this));
            }

            var avatarColor;
            if (this.resolved.message) {
                var twitchTags = this.resolved.message.getTwitchTags();
                if (twitchTags) {
                    if (!this.resolved.isSelf() && twitchTags['color']) {
                        avatarColor = twitchTags['color'];
                    }
                }
            }
 
            var displayAuthor = this.resolved.getDisplayAuthor();
            if (this.resolved.message) {
                var relayMsgParts = this.resolved.message.relayMsgParts(
                    this.resolved.message.getDisplayAuthor() || displayAuthor || nick
                );
                displayAuthor = relayMsgParts.nick;
            }
            img = img.add(this.formatter.avatar(nick, this.resolved.isSelf(), {
                color: avatarColor,
                name: displayAuthor,
                fallback: !!avatar,
                external: external
            }));
        }
        return img;
    },
    afterShow: function () {
        this.focusMessage();
    },
    focusMessage: function () {
        this.message.focus().select();
    },
    submitForm: function (e) {
        e.preventDefault();
        this.$el.hide();
        this.closed();
        this.resolved.say(this.message.val(), {
            onConfirm: _.bind(function () {
                this.opened();
                this.hide();
            }, this),
            onCancel: _.bind(function () {
                this.$el.show();
                this.opened();
                this.focusMessage();
            }, this)
        });
    },
    clickOpen: function (e) {
        this.resolved.openBuffer();
        return false;
    },
    clickInvite: function (e) {
        this.hide();
        this.resolved.connection.trigger('invitePrompt', this.resolved);
        return false;
    },
    clickIgnore: function (e) {
        this.hide();
        this.resolved.connection.trigger('ignorePrompt', this.resolved);
        return false;
    },
    clickRelayBotEnable: function (e) {
        this.hide();
        this.resolved.connection.setRelayBot(this.resolved.getName());
        return false;
    },
    clickRelayBotDisable: function (e) {
        this.hide();
        this.resolved.connection.unsetRelayBot(this.resolved.getName());
        return false;
    },
    // Prefer member so we can use the ircserver field
    clickWhois: function (e) {
        e.preventDefault();
        (this.member || this.resolved).whois();
        this.hide();
    },
    // In channels only (doesn't need to be a current member)
    clickBan: function (e) {
        if (this.buffer && this.buffer.isChannel()) {
            this.hide();
            this.buffer.trigger('banPrompt', this.resolved);
        }
        return false;
    },
    // Current channel members only
    clickKick: function (e) {
        if (this.member && this.buffer && this.buffer.isChannel()) {
            this.hide();
            this.buffer.trigger('kickPrompt', this.resolved);
        }
        return false;
    },
    clickOp: function (e) {
        e.preventDefault();
        if (this.member && this.buffer && this.buffer.isChannel()) {
            this.buffer.op(this.resolved);
        }
        this.hide();
    },
    clickDeop: function (e) {
        e.preventDefault();
        if (this.member && this.buffer && this.buffer.isChannel()) {
            this.buffer.deop(this.resolved);
        }
        this.hide();
    },
    clickVoice: function (e) {
        e.preventDefault();
        if (this.member && this.buffer && this.buffer.isChannel()) {
            this.buffer.voice(this.resolved);
        }
        this.hide();
    },
    clickDevoice: function (e) {
        e.preventDefault();
        if (this.member && this.buffer && this.buffer.isChannel()) {
            this.buffer.devoice(this.resolved);
        }
        this.hide();
    }
});


module.exports = MemberContextMenuView;



//////////////////
// WEBPACK FOOTER
// ./app/src/view/membercontextmenuview.js
// module id = zeA3
// module chunks = 1